import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { forwardRef } from "react";
import type { PropsWithChildren } from "react";

interface DescriptionContainerProps {
  className?: string;
  style?: Record<string, string | number>;
}

export const DescriptionContainer = forwardRef<
  HTMLDivElement,
  PropsWithChildren<DescriptionContainerProps>
>(({ children, className, style = {} }, ref) => (
  <div
    ref={ref}
    className={classNames(
      "flex flex-col gap-y-6 md:gap-y-8 items-center",
      className,
    )}
    data-testid="upsell-description-container"
    style={style}
  >
    {children}
  </div>
));

DescriptionContainer.displayName = "DescriptionContainer";
